import { render, staticRenderFns } from "./UiDropdown.vue?vue&type=template&id=6427a618&scoped=true&"
import script from "./UiDropdown.vue?vue&type=script&lang=js&"
export * from "./UiDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UiDropdown.vue?vue&type=style&index=0&id=6427a618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427a618",
  null
  
)

export default component.exports